module.exports = __webpack_public_path__ + "media/images/closet_door-97e3ad9a61ee062fcb836aafd41f0361.jpg";